/* src/app/modules_v2/finance/credit-policy/components/credit-policy-detail/credit-policy-detail.component.scss */
:host {
  display: block;
}
.cp-panel {
  display: grid;
  grid-template-columns: minmax(260px, 1fr) minmax(0, 1.4fr);
  gap: 16px;
}
.cp-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 14px 16px;
  min-width: 0;
}
.cp-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}
.cp-card__title,
.cp-block__title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 700;
  color: #1a1d23;
}
.cp-card__title mat-icon,
.cp-block__title mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #6b7280;
}
.cp-kpis {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}
.cp-kpi {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 10px;
  background: #f4f6f8;
  border-radius: 8px;
  min-width: 0;
}
.cp-kpi--accent {
  background: #fbfee8;
  border: 1px solid #e5f3a0;
}
.cp-kpi__label {
  font-size: 11px;
  color: #6b7280;
}
.cp-kpi__value {
  font-size: 14px;
  font-weight: 700;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cp-progress {
  margin-top: 12px;
}
.cp-progress__bar {
  height: 8px;
  border-radius: 999px;
  background: #eef1f4;
  overflow: hidden;
}
.cp-progress__fill {
  height: 100%;
  border-radius: 999px;
  background: #c5d94a;
  transition: width 0.3s ease;
}
.cp-progress__fill--over {
  background: #dc2626;
}
.cp-progress__legend {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 6px;
  font-size: 12px;
  color: #6b7280;
}
.cp-progress__legend strong {
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
}
.cp-lines {
  display: flex;
  flex-direction: column;
  margin-top: 12px;
  border: 1px solid #eef1f4;
  border-radius: 8px;
  overflow: hidden;
}
.cp-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 7px 12px;
  font-size: 13px;
  color: #2f3540;
}
.cp-line + .cp-line {
  border-top: 1px solid #eef1f4;
}
.cp-line__label {
  color: #6b7280;
  white-space: nowrap;
}
.cp-line__value {
  font-weight: 600;
  text-align: right;
  min-width: 0;
  overflow-wrap: anywhere;
}
.cp-block {
  padding: 10px 0;
}
.cp-block + .cp-block {
  border-top: 1px solid #eef1f4;
}
.cp-block__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}
.cp-block__side {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}
.cp-block__summary {
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
}
.cp-block__summary strong {
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
}
.cp-add.cf-btn.mat-mdc-button-base {
  height: 28px !important;
  padding: 0 10px !important;
  font-size: 12px !important;
}
.cp-add.cf-btn.mat-mdc-button-base .mat-icon {
  font-size: 16px !important;
  width: 16px !important;
  height: 16px !important;
  margin-right: 2px !important;
}
.cp-moves {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.cp-move {
  display: grid;
  grid-template-columns: 90px minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 10px;
  padding: 6px 6px 6px 10px;
  background: #f9fafb;
  border: 1px solid #eef1f4;
  border-radius: 6px;
  font-size: 13px;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.cp-move:hover {
  background: #fff;
  border-color: #e5e7eb;
}
.cp-move__date {
  color: #6b7280;
  white-space: nowrap;
}
.cp-move__info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.cp-move__concept,
.cp-move__meta {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cp-move__concept {
  color: #2f3540;
}
.cp-move__meta {
  font-size: 11px;
  color: #6b7280;
}
.cp-move__amount {
  font-weight: 700;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.cp-move__actions {
  display: flex;
  align-items: center;
  gap: 2px;
}
.cp-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #9ca3af;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.cp-icon-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.cp-icon-btn:hover {
  background: #f3f4f6;
  color: #1a1d23;
}
.cp-icon-btn--danger:hover {
  background: #fef2f2;
  color: #dc2626;
}
.cp-more {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: 2px;
  margin-top: 2px;
  padding: 2px 6px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  font-size: 12px;
  font-weight: 600;
  color: #4b5563;
  cursor: pointer;
}
.cp-more mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.cp-more:hover {
  background: #f3f4f6;
  color: #1a1d23;
}
.cp-block__empty {
  font-size: 12px;
  color: #9ca3af;
  padding: 2px 0;
}
.cp-empty {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 12px 14px;
  background: #f9fafb;
  border: 1px dashed #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  color: #6b7280;
}
.cp-empty mat-icon {
  flex-shrink: 0;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.cp-empty--error mat-icon {
  color: #dc2626;
}
@media (max-width: 900px) {
  .cp-panel {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 480px) {
  .cp-kpis {
    grid-template-columns: 1fr;
  }
  .cp-move {
    grid-template-columns: minmax(0, 1fr) auto auto;
  }
  .cp-move__date {
    grid-column: 1/-1;
  }
}
/*# sourceMappingURL=credit-policy-detail.component.css.map */
